//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../Motion/Motion.SelectLink.js";
import "../no/Expression.js";
import "../Motion/Motion.SelectFieldData.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"ActionLink",0,"Motion.SelectLink",0],[0,"ActionLinkOvrCtrl",1,0],[0,"Applicationtype",1,0],[0,"Csys",1,0],[0,"Direction",1,"Direction",0],[0,"DisplayScale",1,0],[0,"MagFunction",1,"CAE.Function",0],[1,"MagnitudeExpression",0,"Expression",0],[1,"MagnitudeProfile",0,"Motion.SelectFieldData",0],[0,"MagnitudeValueType",1,0],[0,"Name",1,0],[0,"Origin",1,"Point",0],[0,"OriginOvrCtrl",1,0],[1,"ReactionLink",0,"Motion.SelectLink",0],[0,"ReactionLinkOvrCtrl",1,0],[0,"ReactionOrigin",1,"Point",0],[0,"ReactionOriginOvrCtrl",1,0],[0,"ReferenceCsys",1,"CoordinateSystem",0],[0,"ReferenceCsysOvrCtrl",1,0],[0,"ReferenceDirection",1,"Direction",0],[0,"ReferenceDirectionOvrCtrl",1,0],[1,"ReferenceLink",0,"Motion.SelectLink",0],[0,"ReferenceLinkOvrCtrl",1,0],[0,"ReferenceOrigin",1,"Point",0],[0,"ReferenceOriginOvrCtrl",1,0],[0,"ValueType",1,0],[1,"XExpression",0,"Expression",0],[0,"XFunction",1,"CAE.Function",0],[1,"XProfile",0,"Motion.SelectFieldData",0],[0,"XValueType",1,0],[1,"YExpression",0,"Expression",0],[0,"YFunction",1,"CAE.Function",0],[1,"YProfile",0,"Motion.SelectFieldData",0],[0,"YValueType",1,0],[1,"ZExpression",0,"Expression",0],[0,"ZFunction",1,"CAE.Function",0],[1,"ZProfile",0,"Motion.SelectFieldData",0],[0,"ZValueType",1,0]],[],[]];
SPLM.Motion.VObject = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.VObject";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.VobjectCsysType = Object.freeze({
    "Userdefined" : "Userdefined", "Absolute" : "Absolute"});

SPLM.Motion.VobjectApplicationType = Object.freeze({
    "ActionReaction" : "ActionReaction", "ActionOnly" : "ActionOnly"});

export default SPLM;